/* Mega menu DR v3 - Digital Runner
   Desktop: aggancia i pannelli alle voci del menu del tema con lo stesso testo
   (es. "Integratori"), li apre al passaggio del mouse, con tastiera e al tocco.
   Mobile: sostituisce il sottomenu della voce nel menu a scomparsa del tema con il contenuto DR.
   Nessun file del tema viene modificato: tutto parte da questa sezione. */
(function () {
  if (window.__mmDrLoaded) return;
  window.__mmDrLoaded = true;

  var OPEN_DELAY = 90;
  var CLOSE_DELAY = 220;

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function $all(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function headerBottom() {
    var h = document.querySelector('sticky-header') || document.querySelector('.header-wrapper') || document.querySelector('header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }

  function init(root) {
    if (!root || root.dataset.mmReady) return;
    root.dataset.mmReady = '1';

    var panels = $all(root, '[data-mm-panel]');
    var backdrop = root.querySelector('[data-mm-backdrop]');
    var openId = null, openTimer = null, closeTimer = null;
    var hosts = {}; // id -> { li, link }

    /* ---------- Desktop: trova le voci del menu del tema ---------- */
    var navLinks = $all(document, '.header__inline-menu .header__menu-item--top, .header__inline-menu > ul > li > a, .header__inline-menu > ul > li > * > a, .header__inline-menu summary');
    panels.forEach(function (p) {
      var id = p.dataset.mmPanel, voce = p.dataset.mmVoce;
      for (var i = 0; i < navLinks.length; i++) {
        var a = navLinks[i];
        var label = a.querySelector('.label') ? a.querySelector('.label').textContent : a.textContent;
        if (norm(label) !== voce) continue;
        var li = a.closest('li');
        if (!li || li.closest('.menu-drawer')) continue;
        li.classList.add('mm-dr-host');
        if (p.hasAttribute('data-mm-small') && !a.querySelector('.icon-caret')) {
          // voce senza sottomenu nel tema (es. Shop): aggiungo la freccina come le altre
          var car = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          car.setAttribute('class', 'icon icon-caret mm-dr-caret');
          car.setAttribute('width', '14'); car.setAttribute('height', '7'); car.setAttribute('viewBox', '0 0 14 7');
          car.setAttribute('fill', 'none'); car.setAttribute('aria-hidden', 'true');
          car.innerHTML = '<path d="M1 1L7 6L13 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>';
          a.appendChild(car);
        }
        a.setAttribute('aria-haspopup', 'true');
        a.setAttribute('aria-expanded', 'false');
        a.setAttribute('aria-controls', p.id);
        hosts[id] = { li: li, link: a };
        bindHost(id, li, a, p);
        break;
      }
    });

    function place() {
      root.style.setProperty('--mm-top', headerBottom() + 'px');
    }

    function placeSmall(p, link) {
      // tendina piccola: sotto la voce, senza uscire dallo schermo
      var r = link.getBoundingClientRect();
      p.style.top = Math.round(r.bottom + 10) + 'px';
      p.hidden = false;
      var w = p.offsetWidth;
      var left = Math.round(r.left + r.width / 2 - 34);
      left = Math.max(12, Math.min(left, window.innerWidth - w - 12));
      p.style.left = left + 'px';
      p.style.setProperty('--mm-notch', Math.round(r.left + r.width / 2 - left) + 'px');
    }

    function open(id) {
      clearTimeout(closeTimer);
      if (openId === id) return;
      closeNow(true);
      var p = root.querySelector('[data-mm-panel="' + id + '"]');
      if (!p || !hosts[id]) return;
      if (p.hasAttribute('data-mm-small')) {
        root.classList.remove('is-open');
        placeSmall(p, hosts[id].link);
        root.classList.add('is-open-small');
      } else {
        place();
        p.hidden = false;
        root.classList.add('is-open');
      }
      hosts[id].li.classList.add('is-mm-open');
      hosts[id].link.setAttribute('aria-expanded', 'true');
      openId = id;
    }

    function closeNow(keepBackdrop) {
      clearTimeout(openTimer);
      if (openId && hosts[openId]) {
        hosts[openId].li.classList.remove('is-mm-open');
        hosts[openId].link.setAttribute('aria-expanded', 'false');
      }
      panels.forEach(function (p) { p.hidden = true; });
      root.classList.remove('is-open-small');
      if (!keepBackdrop) root.classList.remove('is-open');
      openId = null;
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeNow(); }, CLOSE_DELAY);
    }

    function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

    function warm(p) {
      // le immagini del pannello partono appena il mouse si avvicina alla voce
      if (p.dataset.mmWarm) return;
      p.dataset.mmWarm = '1';
      $all(p, 'img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    }

    function bindHost(id, li, a, p) {
      li.addEventListener('pointerenter', function () { warm(p); });
      a.addEventListener('focus', function () { warm(p); });
      li.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(id); }, openId ? 0 : OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () { if (isDesktop()) scheduleClose(); });
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', scheduleClose);

      // Tocco su tablet/desktop touch: primo tocco apre, secondo segue il link
      a.addEventListener('click', function (e) {
        if (!isDesktop()) return;
        var touch = window.matchMedia('(hover: none)').matches;
        if (touch && openId !== id) { e.preventDefault(); open(id); }
      });

      // Tastiera: freccia giu' o spazio apre ed entra nel pannello
      a.addEventListener('keydown', function (e) {
        if (!isDesktop()) return;
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          open(id);
          var first = p.querySelector('a');
          if (first) first.focus();
        }
      });
    }

    // Esc chiude e torna alla voce; uscendo dal pannello con Tab si chiude
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openId) return;
      var h = hosts[openId];
      closeNow();
      if (h) h.link.focus();
    });
    panels.forEach(function (p) {
      p.addEventListener('focusout', function (e) {
        if (!p.contains(e.relatedTarget)) scheduleClose();
      });
    });
    if (backdrop) {
      backdrop.addEventListener('click', function () { closeNow(); });
      backdrop.addEventListener('mouseenter', scheduleClose);
    }
    window.addEventListener('scroll', function () { if (openId) closeNow(); }, { passive: true });
    window.addEventListener('resize', function () { if (openId) closeNow(); });

    /* ---------- Pulsante promozioni (desktop e menu mobile) ---------- */
    var promoVoce = root.dataset.promoVoce;
    if (promoVoce) {
      var badge = root.dataset.promoBadge || '';
      var stile = root.dataset.promoStile || 'pieno';
      $all(document, '.header__inline-menu a.header__menu-item, .menu-drawer a, .menu-drawer summary').forEach(function (a) {
        var lab = a.querySelector('.label') ? a.querySelector('.label').textContent : a.textContent;
        if (norm(lab) !== promoVoce || a.dataset.mmPromo) return;
        a.dataset.mmPromo = '1';
        a.classList.add('mm-dr-promo', 'mm-dr-promo--' + stile);
        var li = a.closest('li');
        if (li) li.classList.add('mm-dr-promo-li');
        var ico = document.createElement('span');
        ico.className = 'mm-dr-promo__ico';
        ico.setAttribute('aria-hidden', 'true');
        ico.textContent = '%';
        a.insertBefore(ico, a.firstChild);
        if (badge) {
          var b = document.createElement('span');
          b.className = 'mm-dr-promo__badge';
          b.textContent = badge;
          a.appendChild(b);
        }
      });
    }

    /* ---------- Mobile: sostituisce il sottomenu nel menu a scomparsa ---------- */
    $all(root, 'template[data-mm-mobile]').forEach(function (tpl) {
      var id = tpl.getAttribute('data-mm-mobile');
      var sub = document.getElementById('link-' + id);
      if (!sub) {
        // voce con un altro handle: cerca il sottomenu il cui titolo coincide
        var voce = (root.querySelector('[data-mm-panel="' + id + '"]') || {}).dataset;
        voce = voce ? voce.mmVoce : '';
        $all(document, '.menu-drawer__submenu').some(function (s) {
          var t = s.querySelector('.menu-drawer__topbar .menu-drawer__menu-item, .menu-drawer__topbar a');
          if (t && norm(t.textContent) === voce) { sub = s; return true; }
          return false;
        });
      }
      if (!sub) return;
      var inner = sub.querySelector('.menu-drawer__inner-submenu') || sub;
      if (inner.querySelector('.mm-m_dr')) return;
      var list = inner.querySelector(':scope > ul.menu-drawer__menu');
      var content = tpl.content.firstElementChild.cloneNode(true);
      var topbar = inner.querySelector('.menu-drawer__topbar');
      if (topbar) topbar.insertAdjacentElement('afterend', content); else inner.insertBefore(content, inner.firstChild);
      if (list) list.classList.add('mm-dr-replaced');
      inner.classList.add('mm-dr-injected');
      if (sub !== inner) sub.classList.add('mm-dr-sub'); // il sottomenu scorre al suo interno
    });

    /* ---------- Editor tema: selezionando un blocco si apre il suo pannello ---------- */
    document.addEventListener('shopify:block:select', function (e) {
      if (!root.contains(e.target) && !e.target.closest('[data-mm-panel]')) return;
      var p = e.target.closest('[data-mm-panel]');
      if (!p) {
        // blocchi categoria/obiettivo/foto: apre il pannello che li contiene
        p = panels.filter(function (x) { return x.contains(e.target); })[0];
      }
      if (p && isDesktop()) open(p.dataset.mmPanel);
    });
    document.addEventListener('shopify:block:deselect', function () { closeNow(); });
  }

  function initAll() { $all(document, '[data-mm]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mm]');
    if (r) { window.__mmDrLoaded = true; init(r); }
  });
})();
